export default __webpack_public_path__ + "static/media/1.1dd3c76b.png";